import { useScreenSize } from '@/hooks/useScreenSize';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    width?: number;
    height?: number;
    stroke?: string;
    strokeWidth?: number;
};

export const PauseIcon = ({ width = 24, height = 24, stroke = 'currentColor', strokeWidth = 2.4, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M7 20V4" stroke={stroke} strokeWidth={strokeWidth} />
            <path d="M17 20V4" stroke={stroke} strokeWidth={strokeWidth} />
        </svg>
    );
};
